import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import CampaignStatus from "@/models/Campaigns/CampaignStatus";

export default class UpdateCampaignStatusRequest extends BaseUpdateRequest {
    status: CampaignStatus;
}